module.exports = __webpack_public_path__ + "img/ballguide.cd8127b1.svg";